{
  "common.back": "Takaisin",
  "language.label": "Kieli",
  "navbar.internalUser": "Sisäinen näkymä",
  "navbar.reservationNumber": "Avaa {id}",
  "navbar.openReservationInErp": "Avaa varaus {id} varausjärjestelmässä",
  "navbar.locked": "Lukittu",
  "navbar.lockedInfo": "Tämä varaus on lukittu ({status}) eikä sitä voi enää muokata. Näet sen vain luettavana.",
  "navbar.tripFallback": "Matkasi",
  "navbar.stepShort": "Vaihe {current}/{total}",
  "navbar.stepCrumb": "{current}/{total}",
  "navbar.step.1": "Rakenna matkasi",
  "navbar.step.2": "Matkustajien tiedot",
  "navbar.step.3": "Yhteenveto",
  "navbar.step.4": "Maksaminen",
  "navbar.login": "Kirjaudu etuihin",
  "navbar.loginReplacesBooker.title": "Tilisi tiedot tulevat varaajaksi",
  "navbar.loginReplacesBooker.body": "Siirrymme matkustajien tietoihin, joissa voit tarkistaa ne ennen kuin jatkat.",
  "navbar.loginReplacesBooker.confirm": "Jatka kirjautumaan",
  "navbar.loginReplacesBooker.cancel": "Peruuta",
  "navbar.account.open": "Oma tili",
  "navbar.account.fallbackName": "Oma tili",
  "navbar.account.bonus": "Lomabonusta käytettävissä",
  "navbar.account.signOut": "Kirjaudu ulos",
  "landing.noTrip.title": "Valitse matka jatkaaksesi",
  "landing.noTrip.body": "Et ole valinnut matkaa varattavaksi. Tutustu matkavalikoimaamme imt.fi-sivustolla ja palaa varaamaan suosikkimatkasi.",
  "landing.noTrip.cta": "Selaa matkoja",
  "landing.loading": "Ladataan matkaasi…",
  "landing.loadError.title": "Matkan lataaminen epäonnistui",
  "landing.loadError.body": "Emme saaneet avattua matkaasi. Tarkista linkki tai yritä hetken kuluttua uudelleen.",
  "landing.loadError.retry": "Yritä uudelleen",
  "landing.loadError.back": "Selaa matkoja imt.fi:ssä",
  "pricing.title": "Hinnan muodostuminen",
  "pricing.cancellation": "Peruutusturva · {label}",
  "pricing.newsletter": "Uutiskirje-etu",
  "pricing.total": "Yhteensä",
  "pricing.totalPending": "-",
  "pricing.discountCode": "Alekoodi {code}",
  "pricing.paytrailDiscount": "Maksuraja-alennus",
  "pricing.giftCard": "Lahjakortti",
  "pricing.rewardTrip": "Palkintomatka",
  "pricing.bonus": "Lomabonus",
  "pricing.bonusGain": "Kerrytät lomabonusta",
  "pricing.category.Hotel": "Majoitus",
  "pricing.category.Ship": "Laiva",
  "pricing.category.Cruise": "Risteily",
  "pricing.category.Flight": "Lento",
  "pricing.category.BusRouteGroup": "Kuljetus",
  "pricing.category.DuringStayService": "Lisäpalvelut",
  "pricing.category.Extra": "Lisäpalvelut",
  "pricing.category.Other": "Muut",
  "summary.open": "Yhteenveto",
  "summary.trip.title": "Matkan tiedot",
  "summary.trip.name": "Matka",
  "summary.trip.customName": "Oma nimi",
  "summary.trip.dates": "Päivämäärät",
  "summary.trip.passengers": "Matkustajat",
  "summary.dates.night": "1 yö",
  "summary.dates.nights": "{count} yötä",
  "summary.trip.notSelected": "Ei valittu",
  "editor.appbar.back": "Takaisin",
  "editor.entryError.noAvailability.title": "Tälle päivämäärälle ei löydy matkoja",
  "editor.entryError.noAvailability.body": "Valitettavasti tälle lähtöpäivälle ei ole enää saatavilla vapaita paikkoja. Matka on kuitenkin varattavissa muina lähtöpäivinä.",
  "editor.entryError.noAvailability.pickDate": "Valitse toinen päivämäärä",
  "editor.entryError.generic.title": "Matkan avaaminen ei onnistunut",
  "editor.entryError.generic.body": "Emme saaneet avattua matkaasi. Tarkista linkki tai yritä hetken kuluttua uudelleen.",
  "editor.entryError.generic.retry": "Yritä uudelleen",
  "editor.entryError.back": "Palaa takaisin",
  "editor.basics.loading": "Päivitetään matkan tietoja…",
  "editor.basics.editDates": "Muuta päiviä",
  "editor.basics.editPassengers": "Muuta matkustajia",
  "editor.basics.datesEmpty": "Valitse päivät",
  "editor.basics.datesViaTransport": "Valitaan kuljetuksen kanssa",
  "editor.basics.passengersEmpty": "Valitse matkustajat",
  "editor.basics.night": "1 yö",
  "editor.basics.nights": "{count} yötä",
  "editor.basics.dayTrip": "Päivämatka",
  "editor.basics.lead": "Aloita valitsemalla päivät ja matkustajat.",
  "editor.passengers.title": "Matkustajat",
  "editor.passengers.adults": "Aikuiset",
  "editor.passengers.children": "Lapset",
  "editor.passengers.childrenHint": "alle 18 v.",
  "editor.passengers.adultsCount": "Aikuisten määrä",
  "editor.passengers.childrenCount": "Lasten määrä",
  "editor.passengers.maxParty": "Enintään {count} matkustajaa samaan varaukseen.",
  "editor.passengers.maxPartyFlight": "Lentomatkoille voi varata verkossa enintään {count} matkustajaa. Isommille ryhmille teemme tarjouksen erikseen – ota yhteyttä ryhmat@imt.fi.",
  "editor.passengers.decreaseAdults": "Vähennä aikuisia",
  "editor.passengers.increaseAdults": "Lisää aikuisia",
  "editor.passengers.decreaseChildren": "Vähennä lapsia",
  "editor.passengers.increaseChildren": "Lisää lapsia",
  "editor.passengers.childAge": "{index}. lapsen ikä",
  "editor.passengers.childAgeHint": "Lapsen ikä matkan paluupäivänä.",
  "editor.passengers.decreaseChildAge": "Vähennä {index}. lapsen ikää",
  "editor.passengers.increaseChildAge": "Lisää {index}. lapsen ikää",
  "editor.passengers.done": "Valmis",
  "editor.passengers.close": "Sulje",
  "editor.dayPicker.title": "Valitse lähtö- ja paluupäivä",
  "editor.dayPicker.titleDeparture": "Valitse lähtöpäivä",
  "editor.dayPicker.titleReturn": "Valitse paluupäivä",
  "editor.dayPicker.titleFixed": "Vahvista matkasi",
  "editor.dayPicker.close": "Sulje",
  "editor.dayPicker.back": "Takaisin lähtöpäivän valintaan",
  "editor.dayPicker.departureHeading": "Lähtöpäivä",
  "editor.dayPicker.returnHeading": "Paluupäivä",
  "editor.dayPicker.departureOn": "Lähtöpäivä {date}",
  "editor.dayPicker.pickDepartureFirst": "Valitse ensin lähtöpäivä",
  "editor.dayPicker.legendTitle": "Hinta-arvio",
  "editor.dayPicker.tierCheap": "Halvempi",
  "editor.dayPicker.tierBase": "Perus",
  "editor.dayPicker.tierExpensive": "Kalliimpi",
  "editor.dayPicker.tierUnknown": "Ei tiedossa",
  "editor.dayPicker.night": "1 yö",
  "editor.dayPicker.nights": "{count} yötä",
  "editor.dayPicker.fromPerPerson": "Alk. {amount} € / hlö",
  "editor.dayPicker.euroAmount": "{amount} €",
  "editor.dayPicker.capTotal": "alk. yhteensä",
  "editor.dayPicker.capPerPerson": "alk. / hlö",
  "editor.dayPicker.returnOn": "Paluu {date}",
  "editor.dayPicker.expandMore": "Näytä lisää vaihtoehtoja",
  "editor.dayPicker.expandLess": "Näytä vähemmän vaihtoehtoja",
  "editor.dayPicker.commit": "Valitse päivät",
  "editor.dayPicker.commitFixed": "Vahvista",
  "editor.dayPicker.feedbackPickDeparture": "Valitse lähtöpäivä",
  "editor.dayPicker.feedbackPickReturn": "Valitse matkan kesto",
  "editor.dayPicker.feedbackChosen": "Lähtö {departure}, paluu {return}, kesto {duration}",
  "editor.dayPicker.feedbackUnavailable": "{date} ei ole saatavilla. Valitse toiset päivät.",
  "editor.dayPicker.feedbackUnavailableFixed": "{date} on täynnä. Matka järjestetään vain tänä päivänä.",
  "editor.dayPicker.loading": "Ladataan hintoja…",
  "editor.dayPicker.error": "Hintojen lataus epäonnistui.",
  "editor.dayPicker.empty": "Tälle kuukaudelle ei ole lähtöjä.",
  "editor.dayPicker.showMoreMonths": "Näytä lisää kuukausia",
  "editor.dayPicker.loadingDurations": "Haetaan kestoja ja hintoja…",
  "editor.dayPicker.durationsError": "Kestojen hintoja ei saatu haettua. Näytetään arvio.",
  "editor.dayPicker.noBusForDay": "Tälle päivälle ei ole bussia lähtöpaikasta {city}. Valitse toinen päivä.",
  "editor.dayPicker.noBusForFixedDay": "Lähtöpaikasta {city} ei ole bussia {date}. Matka järjestetään vain tänä päivänä, joten valitse toinen lähtökaupunki.",
  "editor.dayPicker.pickCityFirst": "Valitse ensin lähtökaupunki, niin näet bussivaihtoehdot.",
  "editor.dayPicker.pickCity": "Valitse kaupunki",
  "editor.dayPicker.changeCity": "{city} – vaihda",
  "editor.dayPicker.busDirection.label": "Bussin suunta",
  "editor.dayPicker.busDirection.both": "Meno ja paluu",
  "editor.dayPicker.busDirection.outbound": "Vain meno",
  "editor.dayPicker.busDirection.return": "Vain paluu",
  "editor.dayPicker.busLegendOutbound": "Vihreä = {city} menobussi ajaa tänä päivänä",
  "editor.dayPicker.busLegendReturn": "Nuoli = {city} paluubussi ajaa tänä päivänä",
  "editor.dayPicker.busLegendOutboundPlain": "Vihreä = menobussi ajaa tänä päivänä",
  "editor.dayPicker.busLegendReturnPlain": "Nuoli = paluubussi ajaa tänä päivänä",
  "editor.dayPicker.returnBusMark": "Paluubussi",
  "editor.dayPicker.busOutboundLeg": "{origin} (lähtö {time}) – {destination}",
  "editor.dayPicker.busReturnLeg": "{origin} – {destination} (paluu {time})",
  "editor.dayPicker.busLegUntimed": "{origin} – {destination}",
  "editor.busCity.title": "Valitse kaupunki",
  "editor.busCity.lead": "Tarkka pysäkki valitaan jokaiselle matkustajalle erikseen varauksen teon yhteydessä.",
  "editor.busCity.close": "Sulje",
  "editor.busCity.searchPlaceholder": "Hae kaupunkia",
  "editor.busCity.popular": "Suosituimmat",
  "editor.busCity.all": "Kaikki kaupungit",
  "editor.busCity.results": "Hakutulokset",
  "editor.busCity.noResults": "Ei osumia",
  "editor.busCity.loading": "Ladataan lähtöpaikkoja…",
  "editor.busCity.error": "Lähtöpaikkojen lataus epäonnistui.",
  "editor.busCity.noBus": "Ei bussikuljetusta",
  "editor.busCity.noBusSub": "Saapuu itse satamaan",
  "editor.busGroups.title": "Lähtöpaikat",
  "editor.busGroups.lead": "Matkustajat voivat lähteä eri kaupungeista. Jokaisesta lähtöpaikasta tarvitaan vähintään yksi aikuinen.",
  "editor.busGroups.close": "Sulje",
  "editor.busGroups.groupTitle": "{index}. lähtöpaikka",
  "editor.busGroups.remove": "Poista",
  "editor.busGroups.change": "Vaihda",
  "editor.busGroups.add": "Lisää matkustajia toisesta lähtöpaikasta",
  "editor.busGroups.coachOk": "Bussi kulkee valitsemillasi päivillä",
  "editor.busGroups.coachBad": "Ei bussia valitsemillasi päivillä",
  "editor.busGroups.blocked": "Kaikista lähtöpaikoista ei kulje bussia valitsemillasi päivillä. Vaihda lähtöpaikka tai muuta päiviä.",
  "editor.calendar.weekday.1": "MA",
  "editor.calendar.weekday.2": "TI",
  "editor.calendar.weekday.3": "KE",
  "editor.calendar.weekday.4": "TO",
  "editor.calendar.weekday.5": "PE",
  "editor.calendar.weekday.6": "LA",
  "editor.calendar.weekday.7": "SU",
  "editor.calendar.month.1": "tammikuu",
  "editor.calendar.month.2": "helmikuu",
  "editor.calendar.month.3": "maaliskuu",
  "editor.calendar.month.4": "huhtikuu",
  "editor.calendar.month.5": "toukokuu",
  "editor.calendar.month.6": "kesäkuu",
  "editor.calendar.month.7": "heinäkuu",
  "editor.calendar.month.8": "elokuu",
  "editor.calendar.month.9": "syyskuu",
  "editor.calendar.month.10": "lokakuu",
  "editor.calendar.month.11": "marraskuu",
  "editor.calendar.month.12": "joulukuu",
  "editor.steps.dates.title": "Matkustuspäivät",
  "editor.steps.dates.prompt": "Valitse matkustuspäivät",
  "editor.steps.dates.sub": "Valitse meno- ja paluupäivä",
  "editor.steps.dates.subLockedParty": "Avautuu, kun matkustajat on valittu",
  "editor.steps.transport.title": "Kuljetus satamaan",
  "editor.steps.transport.bus.title": "Kotimaan bussikuljetus",
  "editor.steps.transport.self.title": "Saavun itse satamaan",
  "editor.steps.transport.self.sub": "Oma auto tai julkinen liikenne",
  "editor.steps.transport.car.title": "Oma auto mukaan laivalle",
  "editor.steps.transport.car.sub": "Auton paikkavaraus laivalle",
  "editor.steps.transport.hubTitle": "Miten siirryt satamaan?",
  "editor.steps.transport.hubSub": "Valitse kulkutapa satamaan",
  "editor.steps.transport.hubSubBeforeDates": "Valitse kulkutapa, niin näet sille sopivat päivät",
  "editor.steps.transport.hubSummaryBus": "Bussikuljetus satamaan",
  "editor.steps.transport.hubSummaryBusWithCity": "Bussikuljetus satamaan, nouto {city}",
  "editor.steps.transport.hubSummaryBusOut": "Bussi: {city}–satama klo {time}",
  "editor.steps.transport.hubSummaryBusIn": "Bussi: satama–{city} klo {time}",
  "editor.steps.transport.hubSummaryBusOutUntimed": "Bussi: {city}–satama",
  "editor.steps.transport.hubSummaryBusInUntimed": "Bussi: satama–{city}",
  "editor.steps.transport.hubSummaryBusOutOnly": "Bussikuljetus vain satamaan, nouto {city}",
  "editor.steps.transport.hubSummaryBusReturnOnly": "Bussikuljetus vain satamasta, perillä {city}",
  "editor.steps.transport.hubSummaryNoReturnBus": "Paluu satamasta omatoimisesti",
  "editor.steps.transport.hubSummaryNoOutboundBus": "Meno satamaan omatoimisesti",
  "editor.steps.transport.hubSummaryCar": "Oma auto mukana laivalla",
  "editor.steps.transport.hubSummarySelf": "Kuljen itse satamaan",
  "editor.steps.transport.avail.ok": "Hakemasi päivät sopivat",
  "editor.steps.transport.avail.bad": "Valitse toinen päivä",
  "editor.steps.transport.avail.checking": "Tarkistetaan saatavuutta…",
  "editor.steps.transport.avail.pickCity": "Valitse kaupunki",
  "editor.steps.transport.avail.busCity": "Nouto {city}",
  "editor.steps.transport.avail.busOk": "{city} · hakemasi päivät sopivat",
  "editor.steps.transport.avail.busBad": "{city} · valitse toinen päivä",
  "editor.steps.transport.busGroups.add": "Lisää matkustajia toisesta lähtöpaikasta",
  "editor.steps.transport.busGroups.edit": "Muokkaa lähtöpaikkoja",
  "editor.steps.transport.hubSummaryBusGroup": "Bussi: {city} · {party}",
  "editor.steps.transport.hubSummarySelfGroup": "Itse satamaan · {party}",
  "editor.hotelChangeReset.title": "Vaihdetaanko hotelli?",
  "editor.hotelChangeReset.body": "Nykyiseen hotelliin varatut lisäpalvelut poistuvat. Muut valintasi – laivat, hytit ja muut lisäpalvelut – säilyvät.",
  "editor.hotelChangeReset.confirm": "Vaihda hotelli",
  "editor.hotelChangeReset.cancel": "Säilytä nykyinen",
  "editor.ferryChangeReset.title": "Vaihdetaanko laiva?",
  "editor.ferryChangeReset.body": "Tälle laivalle varatut lisäpalvelut poistuvat. Matkan seuraavat osat säilyvät, jos ne sopivat yhteen uuden lähdön kanssa – muuten ne haetaan uudelleen.",
  "editor.ferryChangeReset.confirm": "Vaihda laiva",
  "editor.ferryChangeReset.cancel": "Säilytä nykyinen",
  "editor.tripNotices.title": "Hyvä tietää tästä matkasta",
  "editor.tripNotices.expand": "Näytä lisätiedot",
  "editor.tripNotices.collapse": "Piilota lisätiedot",
  "editor.steps.edit": "Muuta",
  "editor.steps.select": "Valitse",
  "editor.steps.view": "Näytä",
  "editor.steps.collapse": "Valmis",
  "editor.steps.saveError": "Valinnan tallennusta ei voitu varmistaa. Tarkista valintasi ja yritä tarvittaessa uudelleen.",
  "editor.steps.lockedBasics": "Avautuu, kun päivät ja kulku on valittu",
  "editor.steps.lockedDates": "Avautuu, kun päivät on valittu",
  "editor.steps.lockedPrev": "Avautuu, kun {step} on valittu",
  "editor.steps.lockedOptional": "Avautuu, kun edelliset valinnat on tehty",
  "editor.steps.next": "Valitse tämä seuraavaksi",
  "editor.steps.optional": "Vapaaehtoinen — valitse tai ohita",
  "editor.steps.loadError": "Vaihtoehtojen lataaminen epäonnistui.",
  "editor.steps.loadErrorRetry": "Yritä uudelleen",
  "editor.steps.hotel.title": "Hotelli",
  "editor.steps.hotel.titleInCity": "Hotelli · {city}",
  "editor.steps.ferryOut.title": "Menolaiva",
  "editor.steps.ferryOut.summaryTitle": "Menolaiva · {time}",
  "editor.steps.ferryIn.title": "Paluulaiva",
  "editor.steps.ferryIn.summaryTitle": "Paluulaiva · {time}",
  "editor.steps.shipExtra.title": "Lisälaiva",
  "editor.steps.shipExtra.summaryTitle": "Laiva · {time}",
  "editor.steps.cruise.title": "Risteily",
  "editor.steps.cruise.summaryTitle": "Risteily · {time}",
  "editor.steps.flight.title": "Lento",
  "editor.steps.flight.repick": "Lennon varaaminen ei onnistunut. Valitse lento uudelleen.",
  "editor.steps.flight.outboundShort": "Meno {time}",
  "editor.steps.flight.inboundShort": "Paluu {time}",
  "editor.steps.flight.legShort": "Lento {time}",
  "editor.steps.flight.titleWithAirline": "Lennot: {airline}",
  "editor.steps.flight.legRange": "{from} – {to} ({duration})",
  "editor.steps.flight.legRangeNoDuration": "{from} – {to}",
  "editor.steps.flight.legMoment": "{date} klo {time}",
  "flightSheet.title": "Valitse lento",
  "flightSheet.results": "{count} lentoa",
  "flightSheet.resultsOne": "1 lento",
  "flightSheet.close": "Sulje",
  "flightSheet.card.srRoute": "{from} – {to} klo {time}",
  "flightSheet.select": "Valitse",
  "flightSheet.selected": "Valittu",
  "flightSheet.loading": "Etsitään lentoja…",
  "flightSheet.baggage.title": "Hintaan sisältyvät matkatavarat",
  "flightSheet.baggage.carryOn": "Käsimatkatavara yläkaappiin / hlö",
  "flightSheet.baggage.lightBag": "Vain pieni laukku istuimen alle / hlö",
  "flightSheet.baggage.checkedOne": "1 matkalaukku ruumaan / hlö",
  "flightSheet.baggage.checked": "{count} matkalaukkua ruumaan / hlö",
  "flightSheet.baggage.checkedNone": "Ei ruumaan menevää matkalaukkua",
  "flightSheet.baggage.noteLink": "Katso lisätiedot",
  "flightSheet.baggage.outbound": "Meno",
  "flightSheet.baggage.return": "Paluu",
  "flightSheet.baggage.leg": "Lento {number}",
  "flightSheet.bagQuestion.title": "Tarvitsetko ruumaan menevän matkalaukun?",
  "flightSheet.bagQuestion.yes": "Kyllä, otan matkalaukun",
  "flightSheet.bagQuestion.yesHint": "Näytämme lennot, joihin laukku sisältyy",
  "flightSheet.bagQuestion.no": "Ei, matkustan kevyesti",
  "flightSheet.bagQuestion.noHint": "Mukaan pääsee lennosta riippuen pieni laukku tai käsimatkatavara.",
  "flightSheet.bagToggle": "Laukku ruumaan",
  "flightSheet.bagQuestion.listHint": "Näytämme sopivat lennot, kun olet vastannut.",
  "flightSheet.bagQuestion.removed": "Valitsemasi lento ei sisällä ruumaan menevää matkalaukkua. Valitse uusi lento.",
  "flightSheet.sort.label": "Järjestys",
  "flightSheet.sort.recommended": "Suositeltu",
  "flightSheet.sort.cheapest": "Halvin",
  "flightSheet.sort.fastest": "Nopein",
  "flightSheet.filter.button": "Suodata",
  "flightSheet.filter.title": "Suodata lentoja",
  "flightSheet.filter.stopovers": "Vaihdot",
  "flightSheet.filter.stopover.none": "Suora",
  "flightSheet.filter.stopover.one": "Korkeintaan 1 vaihto",
  "flightSheet.filter.stopover.all": "Kaikki",
  "flightSheet.filter.airlines": "Lentoyhtiöt",
  "flightSheet.filter.flightDuration": "Lennon kesto",
  "flightSheet.filter.departureTime": "Lähtöaika",
  "flightSheet.filter.returnTime": "Paluuaika",
  "flightSheet.filter.reset": "Tyhjennä",
  "flightSheet.filter.apply": "Käytä",
  "flightSheet.tag.recommended": "Suositeltu",
  "flightSheet.tag.cheapest": "Halvin",
  "flightSheet.tag.fastest": "Nopein",
  "flightSheet.source.allotment": "Kiintiö",
  "flightSheet.stopover.none": "suora",
  "flightSheet.stopover.one": "1 vaihto",
  "flightSheet.stopover.many": "{count} vaihtoa",
  "flightSheet.duration.hoursMinutes": "{hours} h {minutes} min",
  "flightSheet.duration.hours": "{hours} h",
  "flightSheet.duration.minutes": "{minutes} min",
  "flightSheet.details.layover": "Vaihto {airport} · {duration}",
  "flightSheet.details.terminal": "T{terminal}",
  "flightSheet.showDetails": "Lennon tiedot",
  "flightSheet.hideDetails": "Piilota tiedot",
  "flightSheet.price.included": "Ei lisähintaa",
  "flightSheet.price.extra": "+{amount} € / hlö",
  "flightSheet.price.cheaper": "Säästä {amount} € / hlö",
  "flightSheet.baggageNote.finnair": "Finnairin lennoilla käsimatkatavarat pitää mahtua edessä olevan istuimen alle.",
  "flightSheet.baggageNote.norwegian": "Norwegianin lennoilla käsimatkatavarat pitää mahtua edessä olevan istuimen alle.",
  "flightSheet.noAvailability.title": "Valituille päiville ei ollutkaan lentoja",
  "flightSheet.noAvailability.body": "Yritä valita matkalle uudet päivät niin etsimme uudet lennot.",
  "flightSheet.noAvailability.close": "Sulje",
  "flightSheet.empty": "Hakua vastaavia lentoja ei löytynyt.",
  "flightSheet.error": "Lentojen haku epäonnistui. Yritä uudelleen.",
  "flightSheet.retry": "Yritä uudelleen",
  "flightSheet.filtered.empty": "Yhtään lentoa ei vastaa nykyisiä suodattimia.",
  "flightSheet.filtered.emptyOthers": "Muita lentoja ei vastaa nykyisiä suodattimia.",
  "flightSheet.filtered.clear": "Tyhjennä suodattimet",
  "editor.steps.cancel.title": "Peruutusturva",
  "editor.steps.upsells.title": "Lisäpalvelut",
  "editor.steps.upsells.loading": "Päivitetään lisäpalveluita…",
  "editor.steps.upsells.summaryTitleSelected": "{count} lisäpalvelua valittu",
  "editor.steps.upsells.summaryTitleSelectedOne": "1 lisäpalvelu valittu",
  "editor.steps.upsells.summaryLineSelected": "Lisäpalvelut hotelliin, laivaan ja matkalle",
  "editor.steps.upsells.sheetTitle": "Lisää matkaasi",
  "editor.steps.upsells.sheetClose": "Sulje",
  "editor.steps.upsells.empty": "Tälle matkalle ei ole tarjolla lisäpalveluita.",
  "editor.steps.upsells.toggleError": "Lisäpalvelun päivitys epäonnistui – se ei ehkä ole enää saatavilla. Tarkista valintasi.",
  "editor.steps.upsells.save": "Valmis",
  "editor.steps.upsells.selectedNone": "Ei lisäpalveluita valittuna",
  "editor.steps.upsells.includedSuffix": "/hlö",
  "editor.steps.upsells.perReservationSuffix": "/varaus",
  "editor.steps.upsells.groupShipOutbound": "Menolaivalla",
  "editor.steps.upsells.groupShipInbound": "Paluulaivalla",
  "editor.steps.upsells.groupHotel": "Hotellissa",
  "editor.steps.upsells.groupBus": "Bussiyhteydellä",
  "editor.steps.upsells.groupDuringStay": "Kohteessa",
  "editor.steps.upsells.groupCity": "Kohteessa",
  "editor.steps.upsells.groupOther": "Muut",
  "editor.steps.tickets.title": "Liput",
  "editor.steps.tickets.loading": "Päivitetään lippuja…",
  "editor.steps.tickets.summaryTitleSelected": "{count} lippua valittu",
  "editor.steps.tickets.summaryTitleSelectedOne": "1 lippu valittu",
  "editor.steps.tickets.summaryLineSelected": "Liput matkan tapahtumiin ja nähtävyyksiin",
  "editor.steps.tickets.sheetTitle": "Valitse liput",
  "editor.steps.tickets.sheetClose": "Sulje",
  "editor.steps.tickets.empty": "Tälle matkalle ei ole tarjolla lippuja.",
  "editor.steps.tickets.toggleError": "Lipun päivitys epäonnistui – se ei ehkä ole enää saatavilla. Tarkista valintasi.",
  "editor.steps.tickets.save": "Valmis",
  "editor.steps.tickets.selectedNone": "Ei lippuja valittuna",
  "editor.steps.tickets.count": "{count} lippua",
  "editor.steps.tickets.countOne": "1 lippu",
  "editor.trust.title": "imt.fi - Ikaalisten Matkatoimisto",
  "editor.trust.tagline": "Palvelua vuodesta 1991",
  "editor.trust.legal": "Matkapakettilain suoja",
  "editor.trust.finnish": "Suomalainen",
  "editor.trust.rating": "4,6 / 5 Google-arvio",
  "editor.trust.travellers": "1 000 000+ matkustajaa",
  "editor.cta.book": "Jatka matkustajatietoihin",
  "editor.cta.bookShort": "Jatka",
  "editor.cta.viewPassengers": "Näytä matkustajatiedot",
  "editor.cta.viewPassengersShort": "Matkustajat",
  "editor.cta.hintBasics": "Valitse ensin päivät ja matkustajat",
  "editor.cta.hintSteps": "Tee vielä matkan valinnat",
  "editor.cta.hintNext": "Valitse seuraavaksi {step}",
  "editor.sticky.dateFallback": "Valitse päivät",
  "hotelSheet.title": "Valitse hotelli",
  "hotelSheet.detailTitleOne": "Valitse huone",
  "hotelSheet.detailTitle": "Valitse huoneet",
  "hotelSheet.close": "Sulje",
  "hotelSheet.back": "Takaisin listaan",
  "hotelSheet.results": "{count} hotellia kohteessa {city}",
  "hotelSheet.resultsOne": "1 hotelli kohteessa {city}",
  "hotelSheet.resultsPlain": "{count} hotellia",
  "hotelSheet.resultsPlainOne": "1 hotelli",
  "hotelSheet.loading": "Haetaan hotelleja…",
  "hotelSheet.sort.label": "Järjestä",
  "hotelSheet.sort.value": "Järjestä: {value}",
  "hotelSheet.sort.priceAsc": "Halvin ensin",
  "hotelSheet.sort.priceDesc": "Kallein ensin",
  "hotelSheet.sort.rating": "Paras arvosana",
  "hotelSheet.sort.distance": "Lähimpänä keskustaa",
  "hotelSheet.filter.open": "Suodata",
  "hotelSheet.filter.stars": "Tähtiluokitus",
  "hotelSheet.filter.starsOption": "{count} tähteä",
  "hotelSheet.filter.starsValue": "{value} tähteä",
  "hotelSheet.filter.location": "Sijainti",
  "hotelSheet.filter.score": "Arvosana",
  "hotelSheet.filter.scoreOption": "Arvosana {min}+",
  "hotelSheet.filter.scoreValue": "{min}+",
  "hotelSheet.filter.clear": "Tyhjennä",
  "hotelSheet.filter.showResults": "Näytä {count} hotellia",
  "hotelSheet.filter.showResultsOne": "Näytä 1 hotelli",
  "hotelSheet.filter.distance.near": "Alle 1 km keskustasta",
  "hotelSheet.filter.distance.mid": "1–3 km keskustasta",
  "hotelSheet.filter.distance.far": "Yli 3 km keskustasta",
  "hotelSheet.empty.title": "Ei hotelleja valituilla suodattimilla",
  "hotelSheet.empty.body": "Kokeile väljentää suodattimia nähdäksesi lisää vaihtoehtoja.",
  "hotelSheet.empty.clear": "Tyhjennä suodattimet",
  "hotelSheet.card.select": "Katso huoneet",
  "hotelSheet.card.selected": "Valittu",
  "hotelSheet.card.saleShort": "Ale",
  "hotelSheet.card.notices": "Huomioita",
  "hotelSheet.card.noticesAria": "Huomioita: {hotel}. Avaa hotellin tiedot.",
  "hotelSheet.detail.notices": "Huomioita",
  "hotelSheet.price.included": "Ei lisähintaa",
  "hotelSheet.price.extra": "+{amount} € / hlö",
  "hotelSheet.price.cheaper": "Säästä {amount} € / hlö",
  "hotelSheet.price.includedDiscount": "Sisältää alen {amount} € / hlö",
  "hotelSheet.rating.excellent": "Erinomainen",
  "hotelSheet.rating.veryGood": "Todella hyvä",
  "hotelSheet.rating.good": "Hyvä",
  "hotelSheet.rating.reviews": "{count} arvostelua",
  "hotelSheet.rating.reviewsOne": "1 arvostelu",
  "hotelSheet.rating.reviewsShort": "({count})",
  "hotelSheet.rating.stars": "{count} tähden hotelli",
  "hotelSheet.map.show": "Näytä kartta",
  "hotelSheet.map.showList": "Näytä luettelo",
  "hotelSheet.map.hint": "Voit liikutella ja zoomata karttaa.",
  "hotelSheet.map.unavailable": "Karttaa ei voi näyttää juuri nyt.",
  "hotelSheet.map.loading": "Haetaan hotellien sijainteja…",
  "hotelSheet.map.noLocations": "Näille hotelleille ei löytynyt karttasijaintia.",
  "hotelSheet.map.closeCard": "Sulje hotellikortti",
  "hotelSheet.map.noExtra": "Ei lisähintaa",
  "hotelSheet.map.label": "Kartta hotelleista",
  "hotelSheet.detail.showOnMap": "Näytä kartalla",
  "hotelSheet.detail.customerRating": "imt.fi asiakasarvio",
  "hotelSheet.detail.allPhotos": "Kaikki {count} kuvaa",
  "hotelSheet.detail.photoCount": "{index}/{total}",
  "hotelSheet.detail.prevPhoto": "Edellinen kuva",
  "hotelSheet.detail.nextPhoto": "Seuraava kuva",
  "hotelSheet.detail.amenities": "Hotellin mukavuudet",
  "hotelSheet.detail.why": "Miksi valita {name}?",
  "hotelSheet.detail.exploreArea": "Tutustu alueeseen",
  "hotelSheet.detail.reviewsTitle": "imt.fi asiakasarviot",
  "hotelSheet.detail.ratingOutOf": "{score} / 10",
  "hotelSheet.detail.discountedRooms": "Alennettuja huonehintoja",
  "hotelSheet.detail.checkIn": "Sisäänkirjautuminen",
  "hotelSheet.detail.checkOut": "Uloskirjautuminen",
  "hotelSheet.detail.reception": "Vastaanotto",
  "hotelSheet.detail.gallery": "Hotellin kuvat",
  "hotelSheet.detail.aboutTitle": "Tietoa hotellista",
  "hotelSheet.board.breakfast": "Aamiainen sisältyy",
  "hotelSheet.board.halfBoard": "Puolihoito",
  "hotelSheet.board.fullBoard": "Täysihoito",
  "hotelSheet.board.allInclusive": "All inclusive",
  "hotelSheet.rooms.section": "Huone {index} · {people}",
  "hotelSheet.count.roomsOne": "1 huone",
  "hotelSheet.count.rooms": "{count} huonetta",
  "party.adultsOne": "1 aikuinen",
  "party.adults": "{count} aikuista",
  "party.childrenOne": "1 lapsi",
  "party.children": "{count} lasta",
  "party.adultsAndChildren": "{adults}, {children}",
  "hotelSheet.rooms.loading": "Ladataan huoneita…",
  "hotelSheet.rooms.none": "Ei saatavilla olevia huoneita.",
  "hotelSheet.rooms.error": "Huoneiden lataaminen epäonnistui.",
  "hotelSheet.rooms.retry": "Yritä uudelleen",
  "hotelSheet.rooms.amenities": "Huoneen mukavuudet",
  "hotelSheet.perk.airConditioning": "Ilmastointi",
  "hotelSheet.perk.beach": "Lähellä rantaa",
  "hotelSheet.perk.breakfast": "Aamiainen sisältyy hintaan",
  "hotelSheet.perk.halfBoard": "Puolihoito sisältyy hintaan",
  "hotelSheet.perk.fullBoard": "Täysihoito sisältyy hintaan",
  "hotelSheet.perk.allInclusive": "All inclusive sisältyy hintaan",
  "hotelSheet.perk.city": "Sijaitsee keskustassa",
  "hotelSheet.perk.location": "Sijainti",
  "hotelSheet.perk.sustainability": "Vastuullinen valinta",
  "hotelSheet.perk.bar": "Baari",
  "hotelSheet.perk.bike": "Polkupyöriä käytettävissä",
  "hotelSheet.perk.pool": "Uima-allas",
  "hotelSheet.perk.elevator": "Hissi",
  "hotelSheet.perk.family": "Perhelomakohde",
  "hotelSheet.perk.gym": "Kuntosali",
  "hotelSheet.perk.accessible": "Sopii liikuntarajoitteisille",
  "hotelSheet.perk.kids": "Lasten leikkipaikka",
  "hotelSheet.perk.maleFemale": "Nais- ja miespaikkoja",
  "hotelSheet.perk.parking": "Parkkipaikka",
  "hotelSheet.perk.pets": "Lemmikit sallittu",
  "hotelSheet.perk.restaurant": "Ravintola",
  "hotelSheet.perk.sauna": "Sauna",
  "hotelSheet.perk.sports": "Urheilumahdollisuudet",
  "hotelSheet.perk.swimming": "Kuntouinti",
  "hotelSheet.perk.wifi": "Maksuton WiFi",
  "hotelSheet.perk.tub": "Amme",
  "hotelSheet.perk.shower": "Suihku",
  "hotelSheet.perk.balcony": "Parveke",
  "hotelSheet.perk.frenchBalcony": "Ranskalainen parveke",
  "hotelSheet.perk.minibar": "Minibaari / jääkaappi",
  "hotelSheet.perk.allergyRoom": "Allergiahuone",
  "hotelSheet.perk.safe": "Tallelokero",
  "hotelSheet.perk.coffeeMachine": "Kahvinkeitin",
  "hotelSheet.perk.kettle": "Vedenkeitin",
  "hotelSheet.perk.iron": "Silitysrauta",
  "hotelSheet.perk.smoking": "Tupakointihuone",
  "hotelSheet.perk.roomService": "Huonepalvelu 24 h",
  "hotelSheet.perk.robe": "Kylpytakki",
  "hotelSheet.perk.slippers": "Kylpytossut",
  "hotelSheet.perk.desk": "Kirjoituspöytä",
  "hotelSheet.perk.hairdryer": "Hiustenkuivaaja",
  "hotelSheet.perk.bidet": "Bidee-suihku",
  "hotelSheet.perk.bathProducts": "Ilmaisia kylpytuotteita",
  "hotelSheet.rooms.scarcity": "Vain {count} jäljellä!",
  "hotelSheet.rooms.fallbackName": "Huone {index}",
  "hotelSheet.rooms.showMore": "Näytä lisää",
  "hotelSheet.rooms.showLess": "Näytä vähemmän",
  "hotelSheet.rooms.details": "Huoneen tiedot",
  "hotelSheet.rooms.hideDetails": "Piilota tiedot",
  "hotelSheet.rooms.select": "Valitse",
  "hotelSheet.rooms.included": "Ei lisähintaa",
  "hotelSheet.rooms.deal": "ALE",
  "hotelSheet.rooms.soldOut": "Loppuunmyyty",
  "hotelSheet.split.title": "Huonejako",
  "hotelSheet.split.edit": "Muuta huonejakoa",
  "hotelSheet.split.done": "Valmis",
  "hotelSheet.split.howMany": "Montako huonetta varaatte?",
  "hotelSheet.split.allInOne": "Kaikki samaan huoneeseen",
  "hotelSheet.split.rooms": "{count} huonetta",
  "hotelSheet.split.room": "Huone {index}",
  "hotelSheet.split.moveTo": "Siirrä huoneeseen {index}",
  "hotelSheet.split.moveNew": "Siirrä uuteen huoneeseen",
  "hotelSheet.split.cancel": "Peruuta",
  "hotelSheet.split.warnMax": "Enintään {count} henkilöä huoneessa",
  "hotelSheet.split.warnChildAlone": "Lapsi ei voi majoittua yksin",
  "hotelSheet.split.warnEmpty": "Huoneessa on oltava vähintään yksi matkustaja",
  "hotelSheet.split.note": "Huonejaon muutos vaikuttaa paketin hintaan. Valitse jokaiselle huoneelle huonetyyppi alla.",
  "hotelSheet.split.adult": "Aikuinen {index}",
  "hotelSheet.split.child": "Lapsi {age} v",
  "hotelSheet.split.childNoAge": "Lapsi",
  "hotelSheet.split.moveLabel": "Siirrä matkustaja {name}",
  "hotelSheet.split.summary": "{rooms} · {people}",
  "hotelSheet.footer.total": "Paketti yhteensä",
  "hotelSheet.footer.noRoom": "Huonetta ei valittu",
  "hotelSheet.footer.roomsChosen": "{chosen}/{total} huonetta valittu",
  "hotelSheet.footer.allChosen": "{count} huonetta valittu",
  "hotelSheet.footer.confirmOne": "Vahvista huone",
  "hotelSheet.footer.confirm": "Vahvista huoneet",
  "cancel.Basic.title": "Perus",
  "cancel.Basic.sub": "Kuluton peruutus 7 vrk ennen lähtöä",
  "cancel.Basic.deadline": "7 vrk ennen lähtöä",
  "cancel.Change.title": "Joustava",
  "cancel.Change.sub": "Kuluton peruutus 2 vrk ennen lähtöä",
  "cancel.Change.deadline": "2 vrk ennen lähtöä",
  "cancel.Cancellation.title": "Maksimaalinen",
  "cancel.Cancellation.sub": "Kuluton peruutus 2 h ennen lähtöä",
  "cancel.Cancellation.deadline": "2 tuntia ennen lähtöä",
  "cancel.freeCancel": "Kuluton peruutus sovelluksessa",
  "cancel.terms": "Peruutus on tapahduttava IMT Oma Loma -sovelluksessa. Palautus lomabonuksena, voimassa vuoden.",
  "cancel.priceFree": "Sisältyy",
  "cancel.pricePerPax": "+{amount} €/hlö",
  "cancel.recommended": "Suosittelemme",
  "cancel.general.title": "Kaikkiin matkoihin sisältyvät turvat",
  "cancel.general.intro": "Tuliko muutoksia suunnitelmiin? Ei hätää – IMT.fi:n poikkeuksellinen peruutusturva antaa sinulle mielenrauhan tälle matkalle. Lisäksi jokaiseen IMT.fi-matkaan sisältyvät yleiset muutosturvamahdollisuudet, joista löydät lisätietoa alta sekä matkojen ehdoista ja erityisehdoista.",
  "cancel.general.advisory": "Kuluton peruutusoikeus, jos ulkoministeriö ei suosittele matkustamista",
  "cancel.general.hotline": "Suomenkielinen päivystyspuhelin matkalla turvanasi 24/7",
  "cancel.general.freeCancel": "Kuluton peruutusoikeus 24 tuntia varauksesta, jos lähtöön on vähintään 7 vuorokautta",
  "cancel.general.change": "Muutosoikeus toimistokululla 21 vrk ennen lähtöä",
  "cancel.general.termsLink": "Yleiset matkapakettiehdot",
  "cancel.general.specialTermsLink": "Lisä- ja erityisehdot",
  "cancel.sheetTitle": "Peruutusturva",
  "cancel.sheetClose": "Sulje",
  "passengerInfo.appbar.back": "Takaisin",
  "passengerInfo.appbar.tripFallback": "Matkasi",
  "passengerInfo.appbar.title": "Sinun ja matkaseuran tiedot",
  "passengerInfo.section.booker": "Matkan varaaja",
  "passengerInfo.section.passenger": "Matkustaja {index}",
  "passengerInfo.section.clearPassenger": "Tyhjennä kaikki",
  "passengerInfo.bookerIsGuest": "Olen yksi matkustajista",
  "passengerInfo.card.bookerAsPassenger": "Matkustaja 1 · varaaja",
  "passengerInfo.card.bookerTag": "Varaaja",
  "passengerInfo.card.empty": "Ei vielä täytetty",
  "passengerInfo.card.filled": "täytetty",
  "passengerInfo.card.invalid": "Tarkista syötetyt tiedot",
  "passengerInfo.card.missing": "{count} kenttää puuttuu",
  "passengerInfo.card.missingOne": "1 kenttä puuttuu",
  "passengerInfo.card.fill": "Täytä",
  "passengerInfo.card.edit": "Muuta",
  "passengerInfo.card.collapse": "Valmis",
  "passengerInfo.card.aria": "{role}, {status}",
  "passengerInfo.card.ariaNamed": "{role}, {name}, {status}",
  "passengerInfo.missing.title": "Täytä vielä",
  "passengerInfo.login.ariaLabel": "Kirjautuminen",
  "passengerInfo.login.title": "Kirjaudu, niin matkasi näkyy IMT Oma Loma -sovelluksessa",
  "passengerInfo.login.perkApp": "Kaikki tiedot yhdessä paikassa",
  "passengerInfo.login.perkBonus": "{amount} € lomabonusta",
  "passengerInfo.login.perkChat": "Chat-asiakaspalvelu",
  "passengerInfo.login.signIn": "Kirjaudu",
  "passengerInfo.login.join": "Liity maksutta",
  "passengerInfo.login.guestNote": "Voit varata myös ilman tiliä.",
  "passengerInfo.login.signedInTitle": "Moi, {name}. Täytimme tietosi valmiiksi – tarkistathan ne.",
  "passengerInfo.login.signedInTitleNoName": "Moi! Täytimme tietosi valmiiksi – tarkistathan ne.",
  "passengerInfo.login.signedInApp": "Matka näkyy IMT Oma Loma -sovelluksessa maksun jälkeen",
  "passengerInfo.fields.firstName": "Etunimi (kuten passissa)",
  "passengerInfo.fields.lastName": "Sukunimi (kuten passissa)",
  "passengerInfo.fields.gender": "Sukupuoli",
  "passengerInfo.fields.nationality": "Kansalaisuus",
  "passengerInfo.fields.dateOfBirth": "Syntymäaika (PP.KK.VVVV)",
  "passengerInfo.fields.dateOfBirthRequired": "Syötä syntymäaika.",
  "passengerInfo.fields.dateOfBirthInvalid": "Tarkista syntymäaika — käytä muotoa pp.kk.vvvv.",
  "passengerInfo.fields.dateOfBirthFuture": "Syntymäaika ei voi olla matkan paluupäivän jälkeen.",
  "passengerInfo.fields.dateOfBirthChildMismatch": "Tällä syntymäajalla ikä paluupäivänä on {actual} vuotta, mutta matka on varattu {expected}-vuotiaalle. Korjaa syntymäaika tai muuta lapsen ikää matkan tiedoissa.",
  "passengerInfo.fields.dateOfBirthAdult": "Tällä syntymäajalla ikä paluupäivänä on {actual} vuotta. Matkustajan on oltava vähintään {min}-vuotias — lisää nuoremmat matkan tiedoissa lapsina.",
  "passengerInfo.age.atReturn": "Ikä paluupäivänä {age} vuotta",
  "passengerInfo.fields.phone": "Puhelinnumero (vapaaehtoinen)",
  "passengerInfo.fields.phoneRequired": "Puhelinnumero",
  "passengerInfo.fields.phoneAccountLocked": "Tämä on tilisi kirjautumisnumero, joten sitä ei voi muuttaa varauksella.",
  "passengerInfo.fields.clubOne": "ClubOne-numero (vapaaehtoinen)",
  "passengerInfo.fields.email": "Sähköposti (vapaaehtoinen)",
  "passengerInfo.fields.emailRequired": "Sähköposti",
  "passengerInfo.fields.street": "Lähiosoite",
  "passengerInfo.fields.zip": "Postinumero",
  "passengerInfo.fields.city": "Postitoimipaikka",
  "passengerInfo.fields.ownCarPlate": "Auton rekisterinumero",
  "passengerInfo.fields.companyName": "Yrityksen nimi",
  "passengerInfo.fields.businessId": "Y-tunnus",
  "passengerInfo.fields.businessIdInvalid": "Tarkista Y-tunnus (esim. 1234567-1)",
  "passengerInfo.company.toggle": "Lasku yritykselle",
  "passengerInfo.busStops.title": "Kotimaan kuljetukset",
  "passengerInfo.busStops.origin": "Lähtöpaikka",
  "passengerInfo.busStops.return": "Paluupaikka",
  "passengerInfo.busStops.originStop": "Lähtöpysäkki",
  "passengerInfo.busStops.returnStop": "Paluupysäkki",
  "passengerInfo.busStops.stop": "Bussipysäkki",
  "passengerInfo.busStops.separateReturn": "Haluan eri pysäkit meno- ja paluumatkalle",
  "passengerInfo.busStops.sameReturn": "Sama pysäkki meno- ja paluumatkalle",
  "passengerInfo.busStops.outboundHeading": "Menomatka",
  "passengerInfo.busStops.returnHeading": "Paluumatka",
  "passengerInfo.busStops.returnNote": "Paluumatkalla jäät pois: {stop}",
  "passengerInfo.busStops.noMatchingReturn": "Paluubussi ei pysähdy lähtöpysäkilläsi, joten valitse paluupysäkki erikseen.",
  "passengerInfo.busStops.changeReturn": "Vaihda",
  "passengerInfo.busStops.changeReturnAria": "Valitse paluumatkalle eri pysäkki",
  "passengerInfo.busStops.change": "Muuta",
  "passengerInfo.busStops.changeAria": "Vaihda kaupunki, josta kuljetus lähtee tai johon se palaa",
  "passengerInfo.busStops.saveError": "Muutoksen tallennus epäonnistui. Yritä uudelleen.",
  "passengerInfo.busStops.noTransport": "Ei kuljetusta",
  "passengerInfo.busStops.citiesLoading": "Haetaan kaupunkeja…",
  "passengerInfo.busStops.citiesError": "Kaupunkien haku epäonnistui. Yritä uudelleen.",
  "passengerInfo.busStops.cancel": "Peru",
  "passengerInfo.busStops.saving": "Tallennetaan…",
  "passengerInfo.busStops.applyAll.title": "Sama pysäkki kaikille?",
  "passengerInfo.busStops.applyAll.bodyEveryone": "Haluatko valita saman pysäkin ”{stop}” kaikille matkustajille meno- ja paluumatkalle?",
  "passengerInfo.busStops.applyAll.bodyBothWays": "Haluatko valita saman pysäkin ”{stop}” sekä meno- että paluumatkalle?",
  "passengerInfo.busStops.applyAll.yes": "Kyllä, kaikille",
  "passengerInfo.busStops.applyAll.no": "Ei kiitos",
  "passengerInfo.ownCar.title": "Oma auto laivalla",
  "passengerInfo.gender.male": "Mies",
  "passengerInfo.gender.female": "Nainen",
  "passengerInfo.optIn.promotional": "Kyllä kiitos, lähettäkää sähköpostiin matkauutisia, -tarjouksia ja -vinkkejä.",
  "passengerInfo.optIn.newsletterDiscount": "Tilaa uutiskirje ja saat varauksestasi 1 € alennuksen.",
  "passengerInfo.optIn.itinerary": "Lähetä matkan tiedot kaikille sähköpostiin",
  "passengerInfo.special.title": "Erikoistoivomukset ja muut terveiset",
  "passengerInfo.special.help": "Voit kirjoittaa matkaasi liittyvät toiveet sekä muut terveiset alla olevaan kenttään. imt.fi:n virkailija lukee viestisi ja välittää sen matkaan liittyville toimijoille. Emme kuitenkaan voi luvata kaikkien pyyntöjen toteutumista.",
  "passengerInfo.special.label": "Erikoistoivomukset ja muut terveiset",
  "privacyNote.text": "Tietosi käsitellään turvallisesti imt.fi:n {privacy} mukaisesti.",
  "privacyNote.link": "tietosuojaselosteen",
  "passengerInfo.invoiceRows.title": "Matkustajakohtainen alennus ja lisälaskutus",
  "passengerInfo.invoiceRows.help": "Rivit näkyvät asiakkaalle hinnan erittelyssä selitteineen, ja ne lasketaan mukaan loppusummaan. Rivi tallentuu, kun summa ja selite on täytetty.",
  "passengerInfo.invoiceRows.passenger": "Matkustaja {index}",
  "passengerInfo.invoiceRows.add": "Lisää laskutusrivi",
  "passengerInfo.invoiceRows.addition": "Lisätään",
  "passengerInfo.invoiceRows.subtraction": "Vähennetään",
  "passengerInfo.invoiceRows.amount": "Summa €",
  "passengerInfo.invoiceRows.description": "Selite",
  "passengerInfo.invoiceRows.remove": "Poista laskutusrivi",
  "passengerInfo.invoiceRows.saving": "Tallennetaan…",
  "passengerInfo.invoiceRows.incomplete": "Täytä summa ja selite, niin rivi tallentuu.",
  "passengerInfo.invoiceRows.saveFailed": "Laskutusrivin tallennus epäonnistui. Yritä uudelleen.",
  "passengerInfo.travelStepNotes.title": "Lisätiedot hotellille/palvelulle",
  "passengerInfo.travelStepNotes.help": "Lähetetään hotellille tai palvelulle matkustajalistan mukana. Yksi lisätieto kohdetta kohden; kirjoita se kielellä, jota vastaanottaja ymmärtää.",
  "passengerInfo.travelStepNotes.target": "Hotelli tai palvelu",
  "passengerInfo.travelStepNotes.content": "Lisätieto",
  "passengerInfo.travelStepNotes.add": "Lisää",
  "passengerInfo.travelStepNotes.edit": "Muokkaa",
  "passengerInfo.travelStepNotes.remove": "Poista",
  "passengerInfo.travelStepNotes.save": "Tallenna",
  "passengerInfo.travelStepNotes.cancel": "Peruuta",
  "passengerInfo.travelStepNotes.sunhotels": "Huom! Sunhotels-hotelli: kirjoita lisätieto Sunhotels-agenttiportaalissa.",
  "passengerInfo.travelStepNotes.noSteps": "Varauksessa ei ole hotellia tai palvelua, jolle lisätiedon voisi lähettää.",
  "passengerInfo.travelStepNotes.loadFailed": "Lisätietojen lataaminen epäonnistui.",
  "passengerInfo.travelStepNotes.saveFailed": "Lisätiedon tallennus epäonnistui. Yritä uudelleen.",
  "passengerInfo.cta.continue": "Jatka yhteenvetoon",
  "passengerInfo.cta.continueShort": "Jatka",
  "passengerInfo.state.loading": "Ladataan varausta…",
  "passengerInfo.state.error": "Varauksen lataaminen epäonnistui.",
  "passengerInfo.state.noActiveReservation": "Sinulla ei ole aktiivista varausta.",
  "payment.state.noActiveReservation": "Sinulla ei ole aktiivista varausta.",
  "passengerInfo.cta.saving": "Tallennetaan…",
  "passengerInfo.cta.missingHintGeneric": "Täytä kaikki pakolliset tiedot jatkaaksesi.",
  "passengerInfo.cta.missingOnePerson": "Täydennä vielä yhden henkilön tiedot",
  "passengerInfo.cta.missingPeople": "Täydennä vielä {count} henkilön tiedot",
  "passengerInfo.skipMissing.toggle": "Salli puuttuvat tiedot",
  "passengerInfo.skipMissing.note": "Tyhjät kentät tallennetaan tyhjinä ja ne voi täydentää myöhemmin ERP:ssä. Varaajan puhelinnumero on silti pakollinen, ja täytettyjen kenttien pitää olla oikeassa muodossa.",
  "passengerInfo.skipMissing.gdsFlightWarning": "GDS-lento vaatii jokaisen matkustajan nimen, sukupuolen ja syntymäajan. Jos jatkat ilman niitä, valitse maksuvaiheessa ”Ohita GDS-lentojen varaus”.",
  "passengerInfo.skipMissing.listTitle": "Jää täyttämättä",
  "passengerInfo.skipMissing.continue": "Jatka puutteellisin tiedoin",
  "passengerInfo.skipMissing.hint": "Osa tiedoista jää täyttämättä.",
  "passengerInfo.save.error": "Tietojen tallennus epäonnistui. Yritä uudelleen.",
  "passengerInfo.personSearch.open": "Etsi asiakastiedot",
  "passengerInfo.personSearch.title": "Etsi asiakastiedot",
  "passengerInfo.personSearch.lead": "Hae olemassa oleva asiakas nimellä, syntymäajalla tai varausnumerolla ja liitä hänen tietonsa tähän varaukseen.",
  "passengerInfo.personSearch.close": "Sulje haku",
  "passengerInfo.personSearch.name": "Nimi",
  "passengerInfo.personSearch.dateOfBirth": "Syntymäaika (PP.KK.VVVV)",
  "passengerInfo.personSearch.reservationId": "Varausnumero",
  "passengerInfo.personSearch.hint": "Kirjoita vähintään kaksi kirjainta nimestä, syntymäaika muodossa pp.kk.vvvv tai varausnumero.",
  "passengerInfo.personSearch.loading": "Haetaan asiakkaita…",
  "passengerInfo.personSearch.error": "Asiakashaku epäonnistui. Yritä uudelleen.",
  "passengerInfo.personSearch.noResults": "Ei hakutuloksia. Kokeile toisia hakuehtoja.",
  "passengerInfo.personSearch.noName": "Nimetön asiakas",
  "passengerInfo.personSearch.alreadyInUse": "Käytössä",
  "passengerInfo.personSearch.customerAccount": "Asiakastili",
  "passengerInfo.personSearch.shared": "Muissakin varauksissa",
  "passengerInfo.personSearch.linkError": "Asiakkaan liittäminen epäonnistui. Yritä uudelleen.",
  "passengerInfo.personSearch.linkConflict": "Asiakas on jo matkustajana tässä varauksessa.",
  "passengerInfo.personSearch.detach": "Irrota asiakas tästä varauksesta",
  "passengerInfo.personSearch.editInErp": "Muokkaa asiakkaan tietoja ERP:ssä",
  "passengerInfo.personSearch.lockedNotice": "Asiakas on myös muissa varauksissa, joten hänen tietojaan muokataan ERP:ssä — tämän varauksen kautta ne eivät muutu.",
  "login.dialog.title": "Kirjaudu tilillesi",
  "login.dialog.perksLead": "Kun kirjaudut, matkasi näkyy IMT Oma Loma -sovelluksessa.",
  "login.dialog.perkBonus": "Kerrytät lomabonusta",
  "login.dialog.perkApp": "Kaikki tiedot yhdessä paikassa",
  "login.dialog.perkChat": "Chat-asiakaspalvelu",
  "login.dialog.phoneLead": "Aloita tilaamalla kirjautumiskoodi",
  "login.dialog.phoneLabel": "Puhelinnumerosi",
  "login.dialog.phonePlaceholder": "esim. 040 123 4567",
  "login.dialog.phoneError": "Tarkista puhelinnumero, esim. 040 123 4567.",
  "login.dialog.phoneHint": "Lähetämme kirjautumiskoodin maksuttomana tekstiviestinä antamaasi puhelinnumeroon. Annathan saman numeron, jolla loit kanta-asiakastilisi.",
  "login.dialog.noAccount": "Minulla ei ole tiliä, haluan luoda tilin",
  "login.dialog.haveAccount": "Minulla on jo tili, haluan kirjautua",
  "login.dialog.joinTitle": "Liity maksutta kanta-asiakkaaksi",
  "login.dialog.joinPerksLead": "Kun liityt, matkasi näkyy IMT Oma Loma -sovelluksessa.",
  "login.dialog.joinPhoneLead": "Aloita puhelinnumerollasi",
  "login.dialog.joinContinue": "Jatka",
  "login.dialog.joinPhoneHint": "Tarvitsemme numeron tilin luomiseen. Vahvistamme sen maksuttomalla tekstiviestillä, kun olet täyttänyt tietosi.",
  "login.dialog.registerTitle": "Liity kanta-asiakkaaksi",
  "login.dialog.registerLead": "Luomme tilin numerolle {phone}. Täytä vielä nämä tiedot.",
  "login.dialog.firstName": "Etunimi",
  "login.dialog.lastName": "Sukunimi",
  "login.dialog.email": "Sähköposti",
  "login.dialog.city": "Kotikaupunki",
  "login.dialog.privacyPrefix": "Hyväksyn",
  "login.dialog.privacyPolicyLink": "tietosuojaselosteen",
  "login.dialog.privacyAnd": "ja",
  "login.dialog.privacyTermsLink": "kanta-asiakasehdot",
  "login.dialog.newsletter": "Tilaan uutiskirjeen sähköpostiin. Voin perua sen milloin tahansa uutiskirjeestä löytyvästä peruutuslinkistä.",
  "login.dialog.registerIncomplete": "Täytä kaikki kentät ja hyväksy ehdot.",
  "login.dialog.registerSubmit": "Luo tili",
  "login.dialog.registerBack": "Muokkaa tietoja",
  "login.dialog.creating": "Luodaan tiliä…",
  "login.dialog.registerFailed": "Tilin luominen epäonnistui. Yritä hetken kuluttua uudelleen.",
  "login.dialog.registerPhoneInUse": "Tälle numerolle on jo asiakastili. Kirjaudu sisään sen sijaan.",
  "login.dialog.requestCode": "Tilaa kirjautumiskoodi",
  "login.dialog.sending": "Lähetetään kirjautumiskoodia…",
  "login.dialog.codeTitle": "Syötä kirjautumiskoodi",
  "login.dialog.codeHelp": "Saamasi 6-numeroinen koodi vanhenee 10 minuutin kuluttua.",
  "login.dialog.codeLabel": "Kirjautumiskoodi",
  "login.dialog.signIn": "Kirjaudu",
  "login.dialog.tryAgain": "Yritä uudelleen",
  "login.dialog.tryAnotherNumber": "Kokeile toista numeroa",
  "login.dialog.verifying": "Tarkistetaan koodia…",
  "login.dialog.invalidCode": "Antamasi koodi ei kelpaa. Tarkista ja yritä uudelleen.",
  "login.dialog.requestFailed": "Kirjautumiskoodin lähettäminen epäonnistui. Yritä hetken kuluttua uudelleen.",
  "login.dialog.accountMissingTitle": "Asiakastiliä ei löytynyt",
  "login.dialog.accountMissingHelp": "Antamallesi numerolle ei ole asiakastiliä. Voit kokeilla toista numeroa tai jatkaa varausta ilman kirjautumista.",
  "login.dialog.close": "Sulje",
  "login.dialog.successTitle": "Kirjautuminen onnistui",
  "login.dialog.successHelp": "Tervetuloa! Täytämme varaajan tiedot valmiiksi tililtäsi. Voit muokata niitä tarvittaessa.",
  "login.dialog.successReplacedHelp": "Toimme varaajan tiedot tililtäsi. Tarkista, että ne ovat ajan tasalla, ennen kuin jatkat.",
  "login.dialog.reviewDetails": "Tarkista tiedot",
  "login.dialog.continue": "Jatka",
  "login.dialog.existingAccountTitle": "Sinulla on jo asiakastili",
  "login.dialog.existingAccountHelp": "Antamallesi numerolle löytyy asiakastili. Kirjaudu sisään, niin saat kanta-asiakasetusi käyttöön. Tuomme varaajan tiedot tililtäsi, ja voit tarkistaa, että ne ovat ajan tasalla. Voit myös jatkaa varausta kirjautumatta.",
  "bookingSummary.appbar.back": "Takaisin",
  "bookingSummary.appbar.title": "Yhteenveto",
  "bookingSummary.trip.title": "Matkasi sisältö",
  "bookingSummary.trip.productFallback": "Valittu matkan osa",
  "bookingSummary.trip.baggage": "Lentolippuun sisältyvät matkatavarat",
  "bookingSummary.trip.bus": "Bussi",
  "bookingSummary.trip.included": "Sisältyy matkaan",
  "journeyTimes.arrivesOn": "Saapuu {date}",
  "journeyTimes.via": "via {airports}",
  "bookingSummary.extras.title": "Lisäpalvelut",
  "bookingSummary.extras.cancellation": "Peruutusturva · {label}",
  "bookingSummary.extras.free": "Sisältyy",
  "bookingSummary.passengers.title": "Matkustajat",
  "bookingSummary.passengers.fallback": "Matkustaja {index}",
  "bookingSummary.passengers.adult": "aikuinen",
  "bookingSummary.passengers.child": "lapsi",
  "bookingSummary.passengers.contactTitle": "Yhteystiedot",
  "bookingSummary.passengers.itineraryNoteOne": "Matkavahvistus toimitetaan tähän sähköpostiin",
  "bookingSummary.passengers.itineraryNote": "Matkavahvistus toimitetaan näihin sähköposteihin",
  "bookingSummary.cta": "Jatka maksuun",
  "bookingSummary.ctaShort": "Maksuun",
  "cancellationPolicy.checkDetails.title": "Tarkistathan että matkan ajankohta ja matkustajien tiedot ovat kohdallaan",
  "cancellationPolicy.checkDetails.body": "Välitämme matkustajien tietoja lentoyhtiöille hetimmiten; varaamisen jälkeisten muutosten tekemisestä joudumme veloittamaan toimistokulujen lisäksi myös meille kertyvät todelliset kulut, jotka saattavat lentojen osalta olla niiden täysi hinta.",
  "cancellationPolicy.safeTravel.more": "Lisätietoa",
  "cancellationPolicy.safeTravel.less": "Näytä vähemmän",
  "cancellationPolicy.safeTravel.body": "Jos matka-ajankohtana matkustamista ulkomaille tai valitsemaasi kohteeseen ei Suomen viranomaisten* puolelta suositella, me palautamme maksamasi hinnan täysimääräisenä. Lupaamme palauttaa maksusi viiden arkipäivän kuluessa peruutuksesta.",
  "cancellationPolicy.safeTravel.footnote": "*Suosituksen matkustamisesta antaa viranomaisista ulkoministeriö matkustustiedotteella.",
  "cancellationPolicy.riskFree.title": "Riskitön varaus – voit tehdä muutoksia tai perua matkan kuluitta tänään klo 23 asti!",
  "cancellationPolicy.riskFree.body": "Tarkistathan kuitenkin että matkan ajankohta ja matkustajien tiedot ovat varmasti kohdallaan. Välitämme matkustajien tietoja lentoyhtiöille tänään klo 23 alkaen; tämän jälkeen joudumme veloittamaan muutosten tekemisestä toimistokulujen lisäksi myös meille kertyvät todelliset kulut, jotka saattavat lentojen osalta olla niiden täysi hinta.",
  "tripConditions.euRights": "Sinulle tarjottu matkapalvelujen yhdistelmä on matkapaketti ja sinuun sovelletaan matkapaketteja koskevia EU-oikeuksia. Ikaalisten Matkatoimisto on täysin vastuussa koko matkapaketin asianmukaisesta toteuttamisesta. Lisäksi Ikaalisten Matkatoimisto on hankkinut lainsäädännössä edellytetyn suojan palauttaakseen maksusi ja turvatakseen paluukuljetuksesi siltä varalta, että Ikaalisten Matkatoimistosta tulee maksukyvytön. Lisätietoja direktiivin (EU) 2015/2302 mukaisista {travellerRights}.",
  "tripConditions.euRights.travellerRights": "tärkeimmistä oikeuksista",
  "tripConditions.eyebrow": "Matkapakettiturva",
  "tripConditions.headline": "Yksi varaus – me vastaamme koko matkastasi",
  "tripConditions.benefit.organiser": "{list} samalta vastuulliselta järjestäjältä",
  "tripConditions.benefit.protected": "Maksusi on suojattu, ja paluumatka on turvattu",
  "tripConditions.benefit.refund": "Rahat takaisin, jos viranomaiset eivät suosittele matkustamista",
  "tripConditions.links.travellerRights": "Tärkeimmät oikeutesi",
  "tripConditions.links.packageTerms": "Yleiset matkapakettiehdot",
  "tripConditions.links.specialTerms": "Lisä- ja erityisehdot",
  "tripConditions.teaser": "{list} yhdellä varauksella. Me vastaamme koko matkastasi.",
  "tripConditions.sidebar": "{list} yhdellä varauksella",
  "tripConditions.cta": "Matkapakettiturva",
  "tripConditions.contents.bus": "bussit",
  "tripConditions.contents.busOne": "bussi",
  "tripConditions.contents.flight": "lennot",
  "tripConditions.contents.flightOne": "lento",
  "tripConditions.contents.ship": "laivat",
  "tripConditions.contents.shipOne": "laiva",
  "tripConditions.contents.hotel": "hotellit",
  "tripConditions.contents.hotelOne": "hotelli",
  "tripConditions.contents.and": "ja",
  "tripConditions.contents.fallback": "koko matkasi",
  "bookingSummary.state.loading": "Ladataan yhteenvetoa…",
  "bookingSummary.state.error": "Yhteenvedon lataaminen epäonnistui.",
  "bookingSummary.state.noActiveReservation": "Sinulla ei ole aktiivista varausta.",
  "payment.appbar.back": "Takaisin",
  "payment.appbar.title": "Maksa",
  "payment.method.title": "Valitse maksutapa",
  "payment.method.loading": "Ladataan maksutapoja…",
  "payment.method.error": "Maksutapojen lataus epäonnistui. Yritä uudelleen kohdasta Yhteenveto.",
  "payment.method.alreadyPaid": "Tämä varaus on jo maksettu, joten maksettavaa ei ole.",
  "payment.method.alreadyConfirmed": "Tämä varaus on jo vahvistettu. Voit tarkastella vahvistusta alta.",
  "payment.method.viewConfirmation": "Näytä vahvistus",
  "payment.method.empty": "Maksutapoja ei ole tällä hetkellä saatavilla.",
  "payment.method.priceIncreased": "Matkan hinta on muuttunut varauksen viimeistelyn aikana. Tarkista summa ja jatka uudella hinnalla.",
  "payment.method.priceIncreasedRetry": "Jatka uudella hinnalla",
  "payment.method.priceDecreasedTitle": "Hinta laski",
  "payment.method.priceDecreasedBody": "Matkan hinta laski {from} €:sta {to} €:oon varauksen viimeistelyn aikana. Maksat päivitetyn, edullisemman hinnan.",
  "payment.method.priceChangedTitle": "Maksettava summa muuttui",
  "payment.method.priceChangedBody": "Maksettava summa muuttui {from} €:sta {to} €:oon. Tarkista summa ennen kuin jatkat.",
  "payment.method.discountCodeDroppedTitle": "Alennuskoodi ei enää kelpaa",
  "payment.method.discountCodeDroppedBody": "Alennuskoodia {code} ei voitu enää soveltaa tähän varaukseen, joten se poistettiin. Tarkista summa ennen kuin jatkat.",
  "payment.method.providerUnavailable": "Valitsemasi maksutapa ei ole käytettävissä tähän maksuun. Valitse toinen maksutapa.",
  "payment.method.flightUnavailable": "Valitsemasi lento ei ole enää saatavilla. Palaa valitsemaan uusi lento.",
  "payment.method.hotelUnavailable": "Valitsemasi hotelli ei ole enää saatavilla. Palaa valitsemaan uusi hotelli.",
  "payment.method.rePick": "Takaisin valintoihin",
  "payment.skipGds.lead": "Vaihtoehtoisesti voit ohittaa GDS-varauksen ja laskuttaa varauksen käsin.",
  "payment.skipGds.flight": "Ohita GDS-lentojen varaus.",
  "payment.skipGds.hotel": "Ohita hotellivaraus.",
  "payment.skipGds.invoiceManually": "Ohita GDS ja laskuta käsin",
  "payment.method.processing": "Käsitellään…",
  "payment.providerGroup.mobile": "Mobiilimaksutavat",
  "payment.providerGroup.bank": "Pankkimaksutavat",
  "payment.providerGroup.creditcard": "Korttimaksutavat",
  "payment.providerGroup.credit": "Lasku- ja osamaksutavat",
  "payment.cta.pickProviderHint": "Valitse maksutapa jatkaaksesi.",
  "payment.cta.readyHint": "Sinut ohjataan valitsemaasi maksupalveluun.",
  "payment.cta.pay": "Maksa",
  "payment.cta.payAmount": "Maksa {amount} €",
  "payment.covered.lead": "Varauksen loppusumma on katettu lahjakortilla. Vahvista varaus alla, niin viimeistelemme sen ilman erillistä maksua.",
  "payment.covered.rewardTripLead": "Varauksen loppusumma on katettu palkintomatkalla. Vahvista varaus alla, niin viimeistelemme sen ilman erillistä maksua.",
  "payment.covered.confirm": "Vahvista varaus",
  "payment.covered.hint": "Lahjakortti kattaa loppusumman.",
  "payment.covered.rewardTripHint": "Palkintomatka kattaa loppusumman.",
  "payment.prepay.title": "Paljonko maksat nyt?",
  "payment.prepay.fullName": "Koko summa",
  "payment.prepay.splitName": "Kuluton maksuaika · {percentage} % nyt",
  "payment.prepay.fullSub": "Ei myöhempiä maksuja",
  "payment.prepay.splitInvoice": "Lasku loppuosasta lähetetään sähköpostiin.",
  "payment.prepay.remainderDue": "Loppuosa {amount} € {date} mennessä",
  "payment.prepay.payNow": "Maksetaan nyt",
  "payment.prepay.payLater": "Maksettava myöhemmin",
  "payment.side.tripTotal": "Matkan hinta yhteensä",
  "payment.side.bonusGain": "Kerrytät lomabonusta +{amount} €",
  "payment.actionbar.now": "Nyt",
  "payment.actionbar.terms": "Maksamalla hyväksyt ehdot",
  "payment.type.AllPaytrail": "Verkkomaksu (Paytrail)",
  "payment.type.PaytrailAndEmail": "Ennakko nyt + loppulasku",
  "payment.type.AllEmail": "Sähköpostilasku",
  "payment.type.AllSnailMail": "Paperilasku postitse",
  "payment.type.PaymentLink": "Maksulinkki sähköpostitse",
  "payment.type.DontSend": "Ei lähetystä",
  "payment.type.missingEmail": "Sähköpostiosoite puuttuu",
  "payment.type.missingAddress": "Laskutusosoite puuttuu",
  "payment.invoice.email": "Lasku lähetetään asiakkaalle sähköpostitse.",
  "payment.invoice.snailMail": "Lasku lähetetään asiakkaalle postitse.",
  "payment.invoice.dontSend": "Laskua ei lähetetä – varaus vahvistetaan ilman lähetystä.",
  "payment.invoice.missingFields": "Varaajan tiedot eivät riitä tälle maksutavalle. Täydennä tiedot matkustajatiedoissa.",
  "payment.invoice.confirm": "Vahvista varaus ja luo lasku",
  "payment.invoice.dueDatesLoading": "Haetaan eräpäiviä…",
  "payment.invoice.dueDatesFailed": "Eräpäiviä ei saatu haettua. Ne näkyvät laskulla, kun se on luotu.",
  "payment.invoice.dueDate": "Eräpäivä",
  "payment.invoice.dueDateAdvance": "Ennakkomaksun eräpäivä ({percentage} %)",
  "payment.invoice.dueDateRemainder": "Loppulaskun eräpäivä",
  "payment.invoice.priorPayments": "Varaukselle on jo kirjattu maksuja, joten lasku tehdään vain maksamattomasta osuudesta.",
  "payment.warning.gdsUsePaymentLink": "Huom! GDS-varaus, käytä maksulinkkiä.",
  "payment.warning.gdsSnailMailDueToday": "Matka sisältää Sabre-lentoja, joten eräpäiväksi asetetaan tämä päivä. Paperilasku ei välttämättä ehdi perille.",
  "payment.warning.snailMailLate": "Matkan alkuun on enintään 5 päivää, joten eräpäiväksi asetetaan tämä päivä. Paperilasku ei välttämättä ehdi perille.",
  "payment.warning.paymentLinkInProgress": "Varaus on Kesken-tilassa, joten asiakas ei voi käyttää maksulinkkiä. Aseta varaus ERP:ssä Alustava-tilaan. Varaus ei peruunnu automaattisesti maksulinkin voimassaoloaikana.",
  "payment.paymentLink.lead": "Asiakkaalle lähetetään sähköpostitse maksulinkki, jolla hän voi maksaa varauksen. Varaus vahvistuu vasta maksun jälkeen.",
  "payment.paymentLink.send": "Lähetä maksulinkki",
  "payment.paymentLink.sent": "Maksulinkki lähetetty asiakkaalle sähköpostitse. Varaus vahvistuu, kun asiakas on maksanut.",
  "payment.terms.terms": "matkaehdot",
  "payment.terms.special": "lisä- ja erityisehdot",
  "payment.terms.consentPay": "Maksamalla hyväksyt {terms} ja {special}.",
  "payment.terms.consentConfirm": "Vahvistamalla hyväksyt {terms} ja {special}.",
  "payment.trust.secure": "Maksunvälittäjänä Paytrail",
  "payment.trust.legal": "Matkapakettiturva",
  "payment.success.title": "Varaus vahvistettu!",
  "payment.success.greeting": "Kiitos! Mahtava päätös varata matka meiltä.",
  "payment.success.bookingNumber": "Varausnumerosi on {id}.",
  "payment.success.prepaid": "Maksoit ennakko-osuuden. Lähetimme loppuosan laskun sähköpostiisi, ja siitä näet summan ja eräpäivän.",
  "payment.success.invoiceDue": "Lasku erääntyy",
  "payment.success.email": "Lähetimme sähköpostiisi tarkempaa tietoa varauksestasi. Välillä viesti kulkeutuu roskapostiin.",
  "payment.success.app": "Lataa seuraavaksi IMT Oma Loma -sovellus",
  "payment.success.appPerk.tripInfo": "Kaikki matkatiedot yhdessä paikassa",
  "payment.success.appPerk.chat": "Chat-asiakaspalvelu",
  "payment.success.appDownload": "Voit ladata sovelluksen täältä:",
  "payment.success.appScan": "Voit skannata QR-koodin puhelimesi kameralla ja ladata sovelluksen.",
  "payment.success.appQrAlt": "QR-koodi, joka avaa sovelluksen latausosoitteen app.imt.fi",
  "payment.success.appLogin": "Kirjaudu sovellukseen numerolla {phone}.",
  "payment.success.close": "Palaa etusivulle",
  "feedback.question": "Kuinka helppoa varauksen tekeminen oli asteikolla 1–5?",
  "feedback.starLabel": "{value}/5",
  "feedback.improve": "Missä voisimme parantaa? (Palautteesi ei vaikuta varaukseesi – haluamme vain oppia ja kehittää palveluamme!)",
  "feedback.idea": "Mistä sait idean varata juuri tämän matkan IMT:ltä?",
  "feedback.send": "Lähetä palaute",
  "feedback.error": "Palautteen lähetys epäonnistui. Yritä uudelleen.",
  "feedback.privacy": "Lue {privacy}, kuinka käsittelemme palautettasi.",
  "feedback.privacyLink": "tietosuojaselosteesta",
  "feedback.thanks.title": "Kiitos palautteesta!",
  "feedback.thanks.body": "Arvostamme todella, että käytit aikaasi auttaaksesi meitä parantamaan palveluamme. Jokainen palaute on meille arvokas, ja se auttaa meitä tarjoamaan entistä paremman kokemuksen sinulle ja muille asiakkaillemme.",
  "giftCard.expand": "Onko sinulla lahjakortti?",
  "giftCard.label": "Lahjakortin koodi",
  "giftCard.placeholder": "esim. 12345-ABC",
  "giftCard.submit": "Käytä lahjakorttia",
  "giftCard.submitting": "Tarkistetaan…",
  "giftCard.cancel": "Peruuta",
  "giftCard.remove": "Poista",
  "giftCard.applied.title": "Lahjakortti käytössä · {amount} €",
  "giftCard.applied.rewardTripTitle": "Palkintomatka käytössä · {amount} €",
  "giftCard.applied.remainingBalance": "Saldoa jää maksun jälkeen {amount} €",
  "giftCard.applied.singleUseValue": "Palkintomatkan arvo {amount} €, käytettävä kerralla",
  "giftCard.error.notFound": "Lahjakorttia ei löytynyt. Tarkista koodi.",
  "giftCard.error.empty": "Lahjakortilla ei ole jäljellä saldoa.",
  "giftCard.error.expired": "Lahjakortin voimassaolo on päättynyt.",
  "giftCard.error.wrongTrip": "Tämä koodi ei käy tälle matkalle.",
  "giftCard.error.alreadyPaid": "Varaus on jo maksettu, lahjakorttia ei voi lisätä.",
  "giftCard.error.unknown": "Lahjakortin lisäys epäonnistui. Yritä uudelleen.",
  "discountCode.expand": "Lisää alennuskoodi",
  "discountCode.label": "Alennuskoodi",
  "discountCode.placeholder": "esim. KESA25",
  "discountCode.submit": "Käytä koodia",
  "discountCode.submitting": "Tarkistetaan…",
  "discountCode.cancel": "Peruuta",
  "discountCode.remove": "Poista",
  "discountCode.applied.title": "Alennuskoodi {code} käytössä",
  "discountCode.applied.amount": "Alennus −{amount} €",
  "discountCode.error.notFound": "Tuntematon alennuskoodi.",
  "discountCode.error.invalid": "Alennuskoodi ei ole voimassa.",
  "discountCode.error.campaignClosed": "Alennuskoodin kampanja-aika ei ole käynnissä.",
  "discountCode.error.wrongDeparture": "Alennuskoodi ei koske tämän matkan lähtöpäivää.",
  "discountCode.error.requiresProduct": "Alennuskoodi edellyttää, että matkaan sisältyy jokin näistä: {products}. Voit vaihtaa valintasi ja kokeilla koodia uudelleen.",
  "discountCode.error.alreadyApplied": "Varauksessa on jo alennuskoodi. Poista se ensin.",
  "discountCode.error.noPriceLeft": "Varauksessa ei ole enää hintaa, josta alennuksen voisi vähentää.",
  "discountCode.error.usableTimesDepleted": "Alennuskoodi on käytetty loppuun.",
  "discountCode.error.unknown": "Alennuskoodin lisäys epäonnistui. Yritä uudelleen.",
  "discountCode.dropped": "Alennuskoodi {code} poistettiin, koska se ei enää koske muuttunutta matkaa.",
  "discountCode.dropped.dismiss": "Selvä",
  "passengerInfo.tripName.dialog.title": "Nimeä matka uudelleen",
  "passengerInfo.tripName.dialog.body": "Voit muuttaa matkan nimen teidän seurueellenne sopivammaksi. Nimen muutos ei vaikuta matkan sisältöön.",
  "passengerInfo.tripName.dialog.hint": "Esimerkiksi ”Perhe Virtasen joulumatka”.",
  "passengerInfo.tripName.dialog.label": "Matkan nimi",
  "passengerInfo.tripName.dialog.reset": "Palauta alkuperäinen nimi",
  "passengerInfo.tripName.dialog.done": "Valmis",
  "passengerInfo.tripName.dialog.close": "Sulje",
  "editor.basicsReset.title": "Muutetaanko matkan tietoja?",
  "editor.basicsReset.body": "Päivien tai matkustajamäärän muuttaminen hakee hotellin, laivat ja lisäpalvelut uudelleen ja nollaa tekemäsi valinnat takaisin oletuksiin.",
  "editor.basicsReset.confirm": "Muuta ja nollaa valinnat",
  "editor.basicsReset.cancel": "Säilytä nykyinen",
  "editor.transportReset.title": "Vaihdetaanko kulkutapa?",
  "editor.transportReset.body": "Tämä kulkutavan vaihto hakee laivat ja hytit uudelleen, ja voi poistaa varaamiasi lisäpalveluita ja lippuja.",
  "editor.transportReset.confirm": "Vaihda ja nollaa valinnat",
  "editor.transportReset.cancel": "Säilytä nykyinen",
  "startOver.crossTrip.title": "Sinulla on jo varaus kesken",
  "startOver.crossTrip.body": "Voit jatkaa aloittamaasi varausta tai aloittaa uuden varauksen juuri avaamallesi matkalle. Uuden varauksen aloittaminen peruu keskeneräisen varauksesi.",
  "startOver.sameTrip.title": "Jatketaanko varaustasi?",
  "startOver.sameTrip.body": "Sinulla on tälle matkalle jo keskeneräinen varaus. Voit jatkaa siitä mihin jäit tai aloittaa alusta. Alusta aloittaminen peruu keskeneräisen varauksesi.",
  "startOver.existingLabel": "Keskeneräinen varauksesi",
  "startOver.requestedLabel": "Juuri avaamasi matka",
  "startOver.reservationNumber": "Varausnumero {id}",
  "startOver.tripFallback": "Matkasi",
  "startOver.requestedTripFallback": "Valitsemasi matka",
  "startOver.resume": "Jatka varausta",
  "startOver.replace": "Aloita uusi varaus",
  "startOver.replaceSameTrip": "Aloita alusta",
  "ferrySheet.outbound.title": "Valitse menolaiva",
  "ferrySheet.inbound.title": "Valitse paluulaiva",
  "ferrySheet.cruise.title": "Valitse risteily",
  "ferrySheet.outbound.empty": "Ei saatavilla olevia menolähtöjä.",
  "ferrySheet.inbound.empty": "Ei saatavilla olevia paluulähtöjä.",
  "ferrySheet.cruise.empty": "Ei saatavilla olevia risteilylähtöjä.",
  "ferrySheet.close": "Sulje",
  "ferrySheet.count": "{count} lähtöä",
  "ferrySheet.countOne": "1 lähtö",
  "ferrySheet.onlyOption": "Tälle matkalle on tarjolla vain yksi laiva – valitse alta paikkasi.",
  "ferrySheet.select": "Valitse",
  "ferrySheet.selected": "Valittu",
  "ferrySheet.price.included": "Ei lisähintaa",
  "ferrySheet.price.includedDiscount": "Sisältää alen {amount} € / hlö",
  "ferrySheet.option.title": "Klo {time} · {ship}",
  "ferrySheet.option.titleNoShip": "Klo {time}",
  "ferrySheet.option.arrival": "Perillä klo {time}",
  "ferrySheet.option.duration": "Matka-aika {duration}",
  "ferrySheet.back": "Takaisin",
  "ferrySheet.card.tag": "Kansipaikka",
  "ferrySheet.card.discountShort": "Ale",
  "ferrySheet.busFilter.count": "{count} bussikuljetukseen sopivaa lähtöä",
  "ferrySheet.busFilter.countOne": "1 bussikuljetukseen sopiva lähtö",
  "ferrySheet.busFilter.showAll": "Näytä kaikki laivat ({count})",
  "ferrySheet.busFilter.showConnecting": "Näytä vain bussikuljetukseen sopivat laivat",
  "ferrySheet.busFilter.notice": "Ei sovi valitun bussikuljetuksen aikatauluun.",
  "ferrySheet.busFilter.noneTitle": "Mikään lähtö ei sovi bussikuljetuksesi aikatauluun.",
  "ferrySheet.busFilter.noneBody": "Näytämme silti kaikki lähdöt. Jos valitset jonkin niistä, bussikuljetusta ei ole tälle lähdölle. Voit myös vaihtaa kuljetustavan satamaan tai valita toiset matkapäivät.",
  "ferrySheet.busFilter.changeTransport": "Vaihda kuljetus satamaan",
  "ferrySheet.bus.toShip": "Bussikuljetus laivalle",
  "ferrySheet.bus.fromShip": "Bussikuljetus laivalta",
  "ferrySheet.bus.operator.imt": "Tilausajo",
  "ferrySheet.notices.title": "Huomioita",
  "ferrySheet.notices.showMore": "Näytä lisää",
  "ferrySheet.notices.showLess": "Näytä vähemmän",
  "timedNotice.untilFurtherNotice": "toistaiseksi",
  "timedNotice.and": "ja",
  "timedNotice.at": "klo",
  "ferrySheet.price.perPerson": "+{amount} € / hlö",
  "ferrySheet.price.total": "+{amount} € yhteensä",
  "ferrySheet.route": "{from} – {to} · klo {departure}–{arrival} · {duration}",
  "ferrySheet.routeTimes": "Klo {departure}–{arrival} · {duration}",
  "ferrySheet.detail.showOnMap": "Näytä kartalla",
  "ferrySheet.detail.about": "Tietoa laivasta",
  "ferrySheet.detail.services": "Laivan palvelut",
  "ferrySheet.footer.total": "Paketti yhteensä",
  "ferrySheet.footer.confirm": "Vahvista valinnat",
  "ferrySheet.footer.noPlace": "Paikkaa ei valittu",
  "ferrySheet.footer.placesChosen": "{chosen}/{total} paikkaa valittu",
  "ferrySheet.footer.allChosen": "{count} paikkaa valittu",
  "cancel.count": "{count} vaihtoehtoa",
  "cancel.countOne": "1 vaihtoehto",
  "cancel.select": "Valitse",
  "cancel.selected": "Valittu",
  "editor.steps.upsells.count": "{count} lisäpalvelua",
  "editor.steps.upsells.countOne": "1 lisäpalvelu",
  "editor.steps.upsells.add": "Lisää",
  "editor.steps.upsells.added": "Lisätty",
  "editor.steps.upsells.readMore": "Lue lisää",
  "editor.steps.upsells.readLess": "Näytä vähemmän",
  "editor.steps.upsells.paxAll": "Lisätty: Kaikille {count} matkustajalle",
  "editor.steps.upsells.paxSome": "Lisätty: {names}",
  "editor.steps.upsells.paxNone": "Valitse matkustajat",
  "editor.steps.upsells.selectionTotal": "Yhteensä {price} €",
  "editor.steps.upsells.remainingQuota": "Vapaana enää {count}",
  "editor.steps.upsells.passengerSoldOut": "Loppuunmyyty",
  "editor.steps.upsells.showMore": "Katso lisää ({count})",
  "editor.steps.upsells.dateTime": "{date} klo {time}",
  "editor.steps.upsells.chooseDay": "Valitse päivä",
  "editor.steps.upsells.fromPrice": "alk. {price}",
  "editor.steps.upsells.openingHours": "Aukioloajat",
  "editor.steps.upsells.closed": "Suljettu",
  "editor.steps.upsells.imageOpen": "Avaa kuva suurempana: {name}",
  "cabinSheet.loading": "Ladataan hyttejä…",
  "cabinSheet.empty": "Ei saatavilla olevia hyttejä.",
  "cabinSheet.setDeck": "Kansipaikat · {people}",
  "cabinSheet.loadError": "Hyttien lataaminen epäonnistui.",
  "cabinSheet.retry": "Yritä uudelleen",
  "cabinSheet.noneForSet": "Tälle matkustajaryhmälle ei ole vapaita hyttejä tällä lähdöllä. Valitse toinen lähtö.",
  "cabinSheet.select": "Valitse",
  "cabinSheet.selected": "Valittu",
  "cabinSheet.price.included": "Ei lisähintaa",
  "cabinSheet.fallbackName": "Hytti {index}",
  "cabinSheet.pickerTitle": "Valitse hytti tai kansipaikka",
  "cabinSheet.pickerTitleCabin": "Valitse hytti",
  "cabinSheet.pickerTitleCabins": "Valitse hytit",
  "cabinSheet.pickerTitleDeck": "Valitse kansipaikka",
  "cabinSheet.section": "Hytti {index} · {people}",
  "cabinSheet.count.cabinsOne": "1 hytti",
  "cabinSheet.count.cabins": "{count} hyttiä",
  "cabinSheet.amenities": "Paikan varustelu",
  "cabinSheet.scarcity": "Vain {count} jäljellä!",
  "placeCard.staffQuota": "Kiintiötä jäljellä: {count}",
  "placeCard.staffUnavailablePrice": "Hinta: {price}",
  "placeCard.staffNoPrice": "Ei hintaa: {products}",
  "placeCard.internalInfo": "Myynnin lisätiedot",
  "placeCard.showUnavailable": "Näytä myös vaihtoehdot, jotka eivät ole saatavilla",
  "placeCard.showUnavailableNote": "Listalla näkyvät myös loppuunmyydyt ja hinnattomat vaihtoehdot. Niitä ei voi valita.",
  "cabinSheet.showMore": "Näytä lisää",
  "cabinSheet.showLess": "Näytä vähemmän",
  "cabinSheet.details": "Lisätietoa",
  "cabinSheet.hideDetails": "Piilota lisätiedot",
  "cabinSheet.deal": "ALE",
  "cabinSheet.price.perPerson": "+{amount} € / hlö",
  "cabinSheet.price.includedDiscount": "Sisältää alen {amount} € / hlö",
  "cabinSheet.split.title": "Hyttijako",
  "cabinSheet.split.edit": "Muuta hyttijakoa",
  "cabinSheet.split.done": "Valmis",
  "cabinSheet.split.howMany": "Montako hyttiä varaatte?",
  "cabinSheet.split.allInOne": "Kaikki samaan hyttiin",
  "cabinSheet.split.cabins": "{count} hyttiä",
  "cabinSheet.split.cabin": "Hytti {index}",
  "cabinSheet.split.moveTo": "Siirrä hyttiin {index}",
  "cabinSheet.split.moveNew": "Siirrä uuteen hyttiin",
  "cabinSheet.split.cancel": "Peruuta",
  "cabinSheet.split.note": "Hyttijaon muutos vaikuttaa paketin hintaan. Valitse jokaiselle hytille paikkatyyppi alla.",
  "cabinSheet.split.warnMax": "Enintään {count} henkilöä hytissä",
  "cabinSheet.split.warnChildAlone": "Lapsi ei voi majoittua yksin",
  "cabinSheet.split.warnEmpty": "Hytissä on oltava vähintään yksi matkustaja",
  "cabinSheet.split.adult": "Aikuinen {index}",
  "cabinSheet.split.child": "Lapsi {age} v",
  "cabinSheet.split.childNoAge": "Lapsi",
  "cabinSheet.split.moveLabel": "Siirrä matkustaja {name}",
  "cabinSheet.split.summary": "{cabins} · {people}",
  "pricing.adult": "Aikuinen {index}",
  "pricing.adultOne": "Aikuinen",
  "pricing.child": "Lapsi {index}",
  "pricing.childOne": "Lapsi",
  "pricing.childAge": "{age} v",
  "pricing.otherShare": "Muut",
  "pricing.sharedLine": "jaettu matkustajien kesken",
  "passengerInfo.tripName.rename": "Nimeä matka",
  "passengerInfo.tripName.error": "Matkan nimen tallennus epäonnistui. Matka säilyi entisellä nimellään – yritä uudelleen."
}
